const veloGroups = {
    0: {
        'name': 'Velo',
        'bikes': [
            {
                id: 1,
                name: 'Kindervelo'
            },
            {
                id: 2,
                name: 'City- und Touringvelos'
            },
            {
                id: 3,
                name: 'MTB Hardtail / Hybrid / Fitness'
            },
            {
                id: 4,
                name: 'MTB Fully'
            },
            {
                id: 5,
                name: 'Rennvelo / Speedbike'
            }
        ]
    },
    1: {
        'name': 'E-Velo',
        'bikes': [
            {
                id: 6,
                name: 'E-Velo City / E-MTB Hardtail'
            },
            {
                id: 7,
                name: 'E-Velo Fully'
            },
        ]
    }
};

export default veloGroups;
